// Polyfills for React Native Web
// This file handles browser-specific polyfills

// Only run in browser environment
if (typeof window !== 'undefined') {
  // Ensure global exists
  if (typeof global === 'undefined') {
    window.global = window;
  }

  // Polyfill for process if it doesn't exist
  if (typeof process === 'undefined') {
    window.process = { env: { NODE_ENV: 'production' } };
  } else if (typeof process.env === 'undefined') {
    process.env = { NODE_ENV: 'production' };
  }

  // Polyfill for __DEV__ if not defined
  if (typeof __DEV__ === 'undefined') {
    window.__DEV__ = typeof process !== 'undefined' &&
                      process.env &&
                      process.env.NODE_ENV !== 'production';
  }

  // NOTE: require() polyfill is now in require-polyfill.js
  // This provides a proper implementation that maps to webpack modules

  // Polyfill for Buffer if not available
  if (typeof Buffer === 'undefined') {
    window.Buffer = class Buffer {
      constructor() {
        console.warn('Buffer is not fully supported in browser environment');
      }
      static from() { return new Buffer(); }
      static alloc() { return new Buffer(); }
    };
  }

  console.log('[Polyfills] Web polyfills loaded successfully');
}

// Export empty object for compatibility
export default {};